// import * as rrweb from 'rrweb'
// const { Recorder, Player } = window.TimeCat
const MAX_NUM = 1024000;
//业务前缀
const BUSINESS_PREFIX = "2b_";
export default {
    data () {
        return {
            //唯一标识
            session_key:'',
            trackEvents:[],
            trackEventsJson:"",
            trackStopFn:undefined,
            startTime:this.formatDate(new Date(),'yyyy-MM-dd hh:mm:ss'),
            page:this.$route.path,
            track_is_new:false, //是否是第一次进入录屏，需要创建新保单
            track_policy_id:undefined,
        }
    },
    methods:{
        //获取sessionkey
        async trackInit () {
            try{
                sessionStorage.removeItem("track_session_key");
                this.session_key = await this.$fetch('/track/session-key');
                sessionStorage.track_session_key = this.session_key;
                this.startRecord();
            }catch (e) {
                console.log(e)
                this.toast('页面录制启动失败','error')
            }
        },
        /**
         * 开始录制
         */
        startRecord () {
            setTimeout(()=> {
                this.trackEvents = [];   
                let that = this;
                this.trackStopFn = rrweb.record({
                    inlineStylesheet:false,
                    recordAfter:"DOMContentLoaded",
                    recordCanvas: true,
                    blockClass:"ivu-select-dropdown",
                    sampling: {
                        // 不录制鼠标移动事件
                        mousemove: false,
                        // 不录制鼠标交互事件
                        mouseInteraction: false,
                        // 设置滚动事件的触发频率
                        scroll: 150, // 每 150ms 最多触发一次
                        // set the interval of media interaction event
                        media: 800,
                        // 设置输入事件的录制时机
                        input: 'last' // 连续输入时，只录制最终值
                    },
                    emit(event) {
                        // 用任意方式存储 event
                        that.trackEvents.push(event);
                        if(JSON.stringify(that.trackEvents).length<MAX_NUM)return;
                        that.trackEventsJson = JSON.stringify(that.trackEvents);
                        // console.log("that.trackEventsJson",that.trackEventsJson.length)
                        that.trackEvents = [];
                        that.insertEvents({});
                        that.startTime = that.formatDate(new Date(),'yyyy-MM-dd hh:mm:ss');
                    },
                });
                console.log('页面开始录制...');
            })
        },
        /**
         * 停止录制并上传
         * @param {*} params 
         */
        async stopRecord (params={}) {
            //is_sync 是否同步，不传这个参数默认走serviceWorker,主要用于跳转第三方链接前
            let { session_key,policy_id,is_new,is_sync,product_no,product_name } = params;
            session_key = session_key || sessionStorage.track_session_key
            if(!policy_id&&params.r){
                // 用于免登陆的分享页面
                policy_id=params.r
            }
            if(!session_key&&!policy_id){
                console.log("session_key,policy_id必须传一下");
                return;
            }
            this.$Loading.start();
            //更新保单id到回溯记录中
            if(!this.track_is_new&&session_key&&policy_id){
                await this.$fetch('/track/update',{
                    method:'POST',
                    // body:querystring.stringify({
                    //     session_key,
                    //     policy_id
                    // })
                    data:{
                        session_key,
                        policy_id:BUSINESS_PREFIX+policy_id,
                        product_no,
                        product_name
                    }
                })
            }
            session_key = session_key || this.session_key;
            !params.onlySave&&this.trackStopFn();
            this.trackEventsJson = JSON.stringify(this.trackEvents);
            console.log('页面停止录制...');
            return this.insertEvents({session_key,policy_id});
        },
        /**
         * 上传页面数据
         */
        async insertEvents ({session_key,policy_id}) {
            session_key = session_key || this.session_key || sessionStorage.track_session_key;
            //如果是第一次进入
            if(this.track_is_new){
                await this.$fetch('/track/create',{
                    method:'POST',
                    data:{
                        session_key:this.session_key,
                        policy_id:policy_id?(BUSINESS_PREFIX+policy_id):""
                    }
                })
                this.track_is_new = false;
            }
            return new Promise((resolve,reject)=>{
                console.log(this.trackEventsJson.length);
                const data = {
                    session_key,
                    page:this.page,
                    start_time:this.startTime,
                    end_time:this.formatDate(new Date(),'yyyy-MM-dd hh:mm:ss'),
                    events:this.trackEventsJson,
                    policy_id:policy_id?(BUSINESS_PREFIX+policy_id):""
                }
                this.$fetch('/track/insert-events',{
                    method:'POST',
                    // body:querystring.stringify(data),
                    data,
                    is_sync:true
                }).then(res=>{
                    //添加sessionkey到下面的页面
                    sessionStorage.track_session_key = session_key;
                    resolve(res)
                }).catch(e=>{
                    this.toast('录制数据提交失败','error')
                    resolve()
                    // reject(false)
                })
            })
        }
    },
    beforeDestroy () {
        this.trackStopFn&&this.trackStopFn();
        // this.trackStopFn&&this.trackStopFn.destroy();
    }
}


// WEBPACK FOOTER //
// ./src/mixin/track.js